module.exports = __webpack_public_path__ + "img/map.0b0e5569.svg";